module.exports = __webpack_public_path__ + "static/img/pic-03.8a91071.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/m/pic-03.png
// module id = vTv7
// module chunks = 1